import { Link } from "react-router-dom";
import { formatAddress, formatBalance } from "../../utils/format";

export default function ContractCalls({ calls, decimals, symbol }) {
  // Ensure calls is an array
  const callsArray = Array.isArray(calls) ? calls : [];

  if (callsArray.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "32px" }}>
        <p style={{ color: "#6b7280" }}>
          No transactions found for this contract
        </p>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "white",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: "#f0f9f8",
              borderBottom: "1px solid #75C4C3",
            }}
          >
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Method
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Transaction Hash
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Block
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              From
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Events
            </th>
            <th
              style={{
                padding: "12px 16px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "600",
                color: "#11545F",
              }}
            >
              Time
            </th>
          </tr>
        </thead>
        <tbody>
          {callsArray.map((call, index) => {
            // Handle both old call format and new extrinsic format
            const isExtrinsic = !!(call.hash && call.indexer);
            const success = isExtrinsic ? call.isSuccess : call.success;
            const method = isExtrinsic
              ? call.decodedMethod ||
                `${call.call?.section}.${call.call?.method}`
              : call.method;
            const timestamp = isExtrinsic
              ? call.indexer?.blockTime
              : call.timestamp;
            const txHash = isExtrinsic ? call.hash : call.txHash;
            const blockHeight = isExtrinsic
              ? call.indexer?.blockHeight
              : call.blockHeight;
            const signer = isExtrinsic ? call.signer : call.caller;
            const eventCount = isExtrinsic ? call.eventsCount : call.gasUsed;

            return (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid #f3f4f6",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f9fafb")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                {/* Status */}
                <td style={{ padding: "12px 16px" }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "500",
                      backgroundColor: success ? "#dcfce7" : "#fef2f2",
                      color: success ? "#166534" : "#dc2626",
                    }}
                  >
                    {success ? "Success" : "Failed"}
                  </span>
                </td>

                {/* Method */}
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#11545F",
                    fontWeight: "500",
                  }}
                >
                  {method || "Contract Call"}
                </td>

                {/* Transaction Hash */}
                <td style={{ padding: "12px 16px" }}>
                  {txHash ? (
                    <Link
                      to={`/extrinsics/${txHash}`}
                      style={{
                        color: "#00868A",
                        textDecoration: "none",
                        fontFamily: "monospace",
                        fontSize: "14px",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#00A786")}
                      onMouseLeave={(e) => (e.target.style.color = "#00868A")}
                    >
                      {formatAddress(txHash)}
                    </Link>
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: "14px" }}>
                      -
                    </span>
                  )}
                </td>

                {/* Block */}
                <td style={{ padding: "12px 16px" }}>
                  <Link
                    to={`/blocks/${blockHeight}`}
                    style={{
                      color: "#00868A",
                      textDecoration: "none",
                      fontSize: "14px",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#00A786")}
                    onMouseLeave={(e) => (e.target.style.color = "#00868A")}
                  >
                    #{blockHeight}
                  </Link>
                </td>

                {/* From */}
                <td style={{ padding: "12px 16px" }}>
                  <Link
                    to={`/accounts/${signer}`}
                    style={{
                      color: "#00868A",
                      textDecoration: "none",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#00A786")}
                    onMouseLeave={(e) => (e.target.style.color = "#00868A")}
                  >
                    {formatAddress(signer)}
                  </Link>
                </td>

                {/* Events/Gas */}
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#11545F",
                  }}
                >
                  {eventCount || "-"}
                </td>

                {/* Time */}
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#6b7280",
                  }}
                >
                  {timestamp
                    ? new Date(timestamp).toLocaleDateString() +
                      " " +
                      new Date(timestamp).toLocaleTimeString()
                    : "Unknown"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
